import { type SxProps } from '@mui/system';
import { YesNoCell } from '../YesNoCell';
import { Wrapper } from './styles';
import { useTheme } from '@mui/styles';
import { colors } from '@mui/material';

type YesNoCellWithColorsProps = {
  value: boolean;
  yesProps?: {
    sx?: SxProps;
  };
};

export const YesNoCellWithColors = ({ value, ...rest }: YesNoCellWithColorsProps) => {
  const theme: any = useTheme();

  const { yesProps = {} } = rest ?? {};

  if (value) {
    return (
      <Wrapper sx={{ backgroundColor: theme.palette.success.main, color: theme.palette.success.dark, ...yesProps?.sx }}>
        <YesNoCell value={value} />
      </Wrapper>
    );
  }
  return (
    <Wrapper sx={{ backgroundColor: colors.red[50], color: colors.red[700] }}>
      <YesNoCell value={value} />
    </Wrapper>
  );
};
